import { PendingCardPaymentsDocument, PendingCardPaymentsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type PendingCardPayment = PendingCardPaymentsQuery['banking']['cardPayments'][number]

interface Props {
  accountId: string
}
export const usePendingCardPayments = ({ accountId }: Props) => {
  const { loading, data } = useQuery(PendingCardPaymentsDocument, {
    variables: { accountId },
    skip: !accountId,
  })

  return {
    loading,
    cardPayments: data?.banking.cardPayments,
  }
}
